import { render, staticRenderFns } from "./OperationsPeriodical.vue?vue&type=template&id=134d3a52"
import script from "./OperationsPeriodical.vue?vue&type=script&lang=js"
export * from "./OperationsPeriodical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports